import { Outlet, RouteObject } from 'react-router-dom';
import { PermissionView } from 'shared/modules/permission/core/PermissionView';
import { VehiclesProvider } from './data/VehiclesProvider';
import { LoadsContextProvider } from '../loads/data/LoadsContext';
import { lazyImport } from 'shared/routing/LazyRoute';
import { ViewLoadPagePrintPage } from 'carrier/loads/LoadsPages';
import { vehiclesSetupRoutes } from './VehiclesSetupRoutes';

const VehiclesPageOutlet = lazyImport(
  () => import('./VehiclesPageOutlet'),
  'VehiclesPageOutlet',
);

const VehiclesPage = lazyImport(() => import('./VehiclesPage'), 'VehiclesPage');

const SubhauledPage = lazyImport(
  () => import('./SubhauledPage'),
  'SubhauledPage',
);

const ViewLoadPage = lazyImport(
  () => import('../loads/view/ViewLoadPage'),
  'ViewLoadPage',
);

const EditLoadPage = lazyImport(
  () => import('../loads/edit-page/EditLoadPage'),
  'EditLoadPage',
);

const CanceledVehiclesPage = lazyImport(
  () => import('./CanceledVehiclesPage'),
  'CanceledVehiclesPage',
);

function VehiclesOutlet() {
  return (
    <PermissionView name="shipments" permission="can_view">
      <LoadsContextProvider>
        <VehiclesProvider>
          <Outlet />
        </VehiclesProvider>
      </LoadsContextProvider>
    </PermissionView>
  );
}

export const vehiclesPageRoutes: RouteObject[] = [
  {
    path: 'vehicles',
    element: <VehiclesOutlet />,
    children: [
      ...vehiclesSetupRoutes,
      {
        element: <VehiclesPageOutlet />,
        children: [
          {
            index: true,
            element: <VehiclesPage />,
          },
          {
            path: ':guid',
            element: <VehiclesPage />,
          },
          {
            path: 'canceled',
            children: [
              {
                index: true,
                element: <CanceledVehiclesPage />,
              },
              {
                path: ':guid',
                element: <CanceledVehiclesPage />,
              },
            ],
          },
          {
            path: 'subhauled',
            children: [
              {
                index: true,
                element: <SubhauledPage />,
              },
              {
                path: 'mark-as-paid/:actionGUID',
                element: <SubhauledPage />,
              },
              {
                path: 'subhaul-load/:actionGUID',
                element: <SubhauledPage />,
              },
              {
                path: 'send-invoice/:actionGUID',
                element: <SubhauledPage />,
              },
              {
                path: 'send-bol/:actionGUID',
                element: <SubhauledPage />,
              },
              {
                path: ':loadGUID',
                children: [
                  {
                    index: true,
                    element: <ViewLoadPage />,
                  },
                  {
                    path: 'edit',
                    element: <EditLoadPage />,
                  },
                  {
                    path: 'print',
                    element: <ViewLoadPagePrintPage />,
                  },
                  {
                    path: ':action?/:actionGUID?',
                    element: <ViewLoadPage />,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
